(function(angular) {
    angular
        .module('repairforms.service.module')
        .service('ToolboxAppService', ToolboxAppService);

    ToolboxAppService.$inject = [];

    function ToolboxAppService(){
        return {
            buildJSONForScanFrom : buildJSONForScanFrom
        };

        function buildJSONForScanFrom(attribute){
            var result = {};

            angular.element('[' + attribute +']').each(function(index, el) {
                var attrValue = angular.element(el).attr(attribute);
                var elemValue = angular.element(el).val();

                if(elemValue) {
                    result[attrValue] = elemValue;
                }
            });

            if(result.firstName || result.lastName) {
                result["contact-name"] = (result.firstName + ' ' + result.lastName).replace(/undefined/g, "").trim();
                delete result.firstName;
                delete result.lastName;
            };

            if (result.street) {
                result["number"] = result.street.substr(0, result.street.indexOf(' '));
                result.street = result.street.substr(result.street.indexOf(' ') + 1);
            };

            return result;
        };

    };

})(angular);